'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _irisPropTypes = require('@spp/iris-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function List(_ref) {
    var items = _ref.items,
        subtype = _ref.subtype,
        theme = _ref.theme,
        stylizr = _ref.stylizr;

    /* eslint-disable react/no-array-index-key */
    var ListItems = items.map(function (item, idx) {
        return _react2.default.createElement(
            'li',
            { key: idx, className: theme.item },
            stylizr(item.value, item.markup)
        );
    });
    /* eslint-enable react/no-array-index-key */

    var ListElement = subtype === 'ordered' ? 'ol' : 'ul';

    return _react2.default.createElement(
        ListElement,
        { className: theme.root + ' ' + theme[subtype] },
        ListItems
    );
};

List.propTypes = {
    items: _propTypes2.default.arrayOf(_irisPropTypes.objects.text).isRequired,
    subtype: _propTypes2.default.oneOf(['ordered', 'unordered']),
    stylizr: _propTypes2.default.func.isRequired,
    theme: _propTypes2.default.shape({
        item: _propTypes2.default.string,
        ordered: _propTypes2.default.string,
        unordered: _propTypes2.default.string
    })
};

List.defaultProps = {
    subtype: 'unordered',
    stylizr: function stylizr(text) {
        return text;
    },
    theme: {}
};

exports.default = List;
//# sourceMappingURL=List.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-list/lib/cjs/List.js
 ** module id = 525
 ** module chunks = 1
 **/